import React from 'react';
import { BaseInstructionScreen, List, InstructionSection } from './BaseInstructionScreen';

const SpeakingInstructions = ({ onBack, onStart }) => {
  return (
    <BaseInstructionScreen
      title="TOEFL Speaking Test"
      icon="🗣️"
      gradientStart="#f1c40f"
      gradientEnd="#f39c12"
      bulletColor="#f1c40f"
      onBack={onBack}
      onStart={onStart}
    >
      <InstructionSection>
        <h2>Test Format</h2>
        <List bulletColor="#f1c40f">
          <li>4 speaking tasks</li>
          <li>17 minutes total time</li>
          <li>Preparation time: 15-30 seconds per task</li>
          <li>Speaking time: 45-60 seconds per task</li>
        </List>
      </InstructionSection>

      <InstructionSection>
        <h2>Task Types</h2>
        <List bulletColor="#f1c40f">
          <li>Task 1: Independent Speaking - Personal Experience</li>
          <li>Task 2: Independent Speaking - Preference</li>
          <li>Task 3: Integrated Speaking - Campus Situation</li>
          <li>Task 4: Integrated Speaking - Academic Course Content</li>
        </List>
      </InstructionSection>

      <InstructionSection>
        <h2>Technical Requirements</h2>
        <List bulletColor="#f1c40f">
          <li>Working microphone required</li>
          <li>Quiet environment recommended</li>
          <li>Test your audio before starting</li>
          <li>Speak clearly and at a natural pace</li>
        </List>
      </InstructionSection>
    </BaseInstructionScreen>
  );
};

export default SpeakingInstructions; 